import axios from "axios";

const BASE_URL = "https://e-commerce-backend-murex.vercel.app/api/v1";

export const getProductsApi = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/products`);
    console.log(response);
    return response.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getSingleProductApi = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}/products/${id}`);
    console.log(response);
    return response.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};
